import { render } from "./AddEditEventModalDialog.vue?vue&type=template&id=dc1a4148&scoped=true&ts=true&lang=pug"
import script from "./AddEditEventModalDialog.vue?vue&type=script&lang=ts"
export * from "./AddEditEventModalDialog.vue?vue&type=script&lang=ts"

import "./AddEditEventModalDialog.vue?vue&type=style&index=0&id=dc1a4148&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Sultan/CMS Admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc1a4148"]])

export default __exports__